import { apiRoute, API_V1 } from '../helpers/api-route'
import { fetchWrapper } from '../helpers/fetch-wrapper'

export const projectService = {
  create,
  update,
  getUserProjects,
  getProjectImages,
  submitProjectImages,
  getAllImages,
  getRejections,
  getProjectImagesSingle,
  startTraining,
  pollTraining,
  getProjectStats,
  getProjectDetailedStats
}

function create (project) {
  return fetchWrapper.post(
    `${apiRoute()}${API_V1}/training/images/projects`,
    project
  )
}
function getProjectDetailedStats (projectId) {
  return fetchWrapper.get(
    `${apiRoute()}${API_V1}/admin/training/details/${projectId}/ai`
  )
}
function getProjectStats (projectId) {
  return fetchWrapper.get(
    `${apiRoute()}${API_V1}/admin/training/stats/${projectId}/ai`
  )
}
function startTraining (project) {
  return fetchWrapper.get(
    `${apiRoute()}${API_V1}/admin/training/start?projectId=${project}`
  )
}
function pollTraining (project) {
  return fetchWrapper.get(
    `${apiRoute()}${API_V1}/admin/training/poll_training?projectId=${project}`
  )
}
function update (project) {
  // // console.log('this is body: ', JSON.stringify(project))
  return fetchWrapper.put(
    `${apiRoute()}${API_V1}/training/images/projects/${project._id}`,
    project
  )
}

function getUserProjects (projectId) {
  return fetchWrapper.get(
    `${apiRoute()}${API_V1}/training/images/projects/${projectId}`
  )
}

function getProjectImages (projectId) {
  return fetchWrapper.get(
    `${apiRoute()}${API_V1}/admin/training/${projectId}/images`
  )
}
function getProjectImagesSingle (projectId, imgId) {
  return fetchWrapper.get(
    `${apiRoute()}${API_V1}/admin/training/${projectId}/images_single/${imgId}`
  )
}
function getRejections (projectId) {
  return fetchWrapper.get(
    `${apiRoute()}${API_V1}/admin/training/${projectId}/rejections/count`
  )
}

function submitProjectImages (projectId, payload) {
  return fetchWrapper.post(
    `${apiRoute()}${API_V1}/admin/training/${projectId}/images`,
    payload
  )
}

function getAllImages (projectId) {
  return fetchWrapper.get(
    `${apiRoute()}${API_V1}/admin/training/all-images/${projectId}`
  )
}


